export const changeModelValues = (obj, updatedValues) => {
    Object.keys(updatedValues).forEach((key) => {
        if (
            updatedValues[key] &&
            typeof updatedValues[key] === 'object' &&
            typeof updatedValues[key] !== null &&
            !Array.isArray(updatedValues[key])
        ) {
            if (!obj[key]) {
                obj[key] = {}
            }
            changeModelValues(obj[key], updatedValues[key])
        } else {
            obj[key] = updatedValues[key]
        }
    })
}


// WEBPACK FOOTER //
// ./src/app/helpers/change-model-values.js